import type { ComponentPropsWithoutRef } from "react";
import classNames from "classnames";

export interface InfoBoxProps extends ComponentPropsWithoutRef<"div"> {
  children: React.ReactNode;
  className?: string;
}

export const InfoBox = ({ children, className, ...rest }: InfoBoxProps) => (
  <div
    className={classNames(
      "bg-tertiary text-dark w-full rounded-lg p-4",
      className,
    )}
    {...rest}
  >
    {children}
  </div>
);
